/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsItalic: {
  name: 'italic';
  data: string;
} = {
  name: 'italic',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 .5H7a.5.5 0 0 0 0 1h1.382l-2.786 13H4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6.618l2.786-13H11a.5.5 0 0 0 0-1Z" fill="currentColor"/></svg>`,
};
